export default ({...props}) => {
  const {palette, size, space} = props.theme
  return `
   &[ap_type="login"]{
        width: ${size(3.125)}vw;
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px;
        height: fit-content;
        margin: auto;
        padding-bottom: ${space(5)}px;

        @media screen and (min-width: 481px) {
            width: ${size(47.5)}px;
        }

        @media screen and (max-width: 480px) {
            width: ${size(11.25)}vw;
        }
    }
    &[ap_type="visit_details"]{
        background-color: ${palette.common.white};
    }
    @media only screen 
    and (min-device-width: 375px) 
    and (max-device-width: 736px) 
    and (-webkit-min-device-pixel-ratio: 2) 
    and (orientation: portrait) {
        &[ap_type="login"]{
            padding-bottom: ${space(2)}px;
        }
    }
`
}
